import apiClient from '../api/axios';

export interface CreateDepartmentPayload {
  organizationId: string;
  branchId: string;
  code: string;
  title: string;
  description: string;
  sourceLanguageId: string | null;
  isSystem: boolean;
}

// Create Department
export const createDepartment = async (data: CreateDepartmentPayload) => {
  const response = await apiClient.post('/departments', data);

  return response.data;
};

// Get Organizations
export const getOrganizations = async () => {
  const response = await apiClient.get('/installations/organizations');

  return response.data;
};

// Get Branches by Organization
export const getBranches = async (organizationId: string) => {
  const response = await apiClient.get(`/branches/organization/${organizationId}`);

  return response.data;
};
